import { Vue, Component, Prop } from "vue-property-decorator";

@Component({
    name: "CustomCard",
})
export default class CustomCard extends Vue {
    @Prop({ default: "grey", type: String, required: true })
    public cardTheme: string;
}
